import { makeAutoObservable } from "mobx"
import exportJobLogService from "@services/export/exportJobLogService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import type {
  IExportJobLog,
  IExportJobLogFilter,
} from "@models/export/exportJobLogModel"

class ExportJobLogStore {
  tableData: PagedResultDto<IExportJobLog> = { items: [], totalCount: 0 }
  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  async getMyExports(params: IExportJobLogFilter) {
    this.isLoading = true
    try {
      this.tableData = await exportJobLogService.getMyExports(params)
    } finally {
      this.isLoading = false
    }
  }

  async download(item: IExportJobLog) {
    await exportJobLogService.download(item)
  }

  async delete(id: number) {
    await exportJobLogService.delete(id)
  }
}

export default ExportJobLogStore
